module.exports = __webpack_public_path__ + "d60279ad32352dbdb246b3678795e1a4.pdf";